<script context="module"></script>
<script>import { createEventDispatcher, getContext } from "svelte";
import FieldContainer from "./helper/FieldContainer.svelte";
import Input from "./helper/Input.svelte";
import Select from "./helper/Select.svelte";
import {
  createFieldContext,
  mergeStateEventDetails
} from "./helper/field.js";
import { buildSelectOptions } from "./forms.js";
export let name = void 0;
export let label;
export let callToInput = void 0;
export let assistText = void 0;
export let story = void 0;
export let value = void 0;
export let error = void 0;
export let disabled = false;
export let units = void 0;
export let control = void 0;
export let locale = void 0;
export let context = void 0;
if (units === void 0) {
  if (control && locale) {
    units = buildSelectOptions(control, locale, context);
  }
}
const contextKey = createFieldContext(
  name,
  value,
  error,
  disabled,
  value?.value === void 0 || value?.unit === void 0
);
const ctx = getContext(contextKey);
const valueContextKey = createFieldContext(name ? `${name}.value` : "", value ? value?.value : void 0, void 0, disabled, value?.value === void 0);
const valueCtx = getContext(valueContextKey);
const unitContextKey = createFieldContext(name ? `${name}.unit` : "", value ? value?.unit : void 0, void 0, disabled, value?.unit === void 0);
const unitCtx = getContext(unitContextKey);
let valueValue = valueCtx.value;
let unitValue = unitCtx.value;
$: {
  ctx.value.set(value);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value?.value === void 0 || value?.unit === void 0);
  $valueValue = value?.value;
  $unitValue = value?.unit;
}
const dispatch = createEventDispatcher();
const valueChanged = (ev) => {
  $valueValue = ev.detail.value;
  updateValue();
};
const unitChanged = (ev) => {
  $unitValue = ev.detail.value;
  updateValue();
};
const valueStateChanged = (ev) => {
  valueStateEventDetails = ev.detail;
  updateState();
};
const unitStateChanged = (ev) => {
  unitStateEventDetails = ev.detail;
  updateState();
};
const updateValue = () => {
  if ($valueValue && $unitValue) {
    const number = parseFloat($valueValue);
    if (!isNaN(number)) {
      if (!value) {
        value = { value: number, unit: $unitValue };
      } else {
        value.value = number;
        value.unit = $unitValue;
      }
    } else {
      value = void 0;
    }
  } else {
    value = void 0;
  }
  dispatch("changed", {
    name,
    value
  });
};
const updateState = () => {
  stateEventDetails = mergeStateEventDetails(valueStateEventDetails, unitStateEventDetails);
  if (ctx)
    ctx.empty.set(stateEventDetails.state.empty);
  if (ctx)
    ctx.dirty.set(stateEventDetails.state.dirty);
  if (ctx)
    ctx.focus.set(stateEventDetails.state.focus);
  if (ctx)
    ctx.visited.set(stateEventDetails.state.visited);
  if (Object.keys(stateEventDetails.changes).length > 0) {
    dispatch("state", stateEventDetails);
  }
};
let valueStateEventDetails;
let unitStateEventDetails;
let stateEventDetails;
$:
  props = {
    label,
    callToInput,
    assistText,
    story,
    contextKey
  };
</script>

<FieldContainer {...props}>
	<svelte:fragment slot="input">
		<Input
			type="text"
			contextKey={valueContextKey}
			on:changed={valueChanged}
			on:state={valueStateChanged}
		/>
	</svelte:fragment>
	<svelte:fragment slot="rest">
		<span class="unit">
			<Select
				options={units}
				contextKey={unitContextKey}
				on:changed={unitChanged}
				on:state={unitStateChanged}
			/>
		</span>
	</svelte:fragment>
</FieldContainer>

<style>
	span.unit {
		display: inline-block;
		width: 8rem;
		padding-left: 1rem;
		border-left: 1px dotted var(--border-color);
		color: var(--text-color);
		font: var(--input-font);
	}
</style>
